// extracted by mini-css-extract-plugin
export default {"ticketSection":"ticketList_ticketSection__igHTI","container":"ticketList_container__56-V3"};